import { createFileRoute } from '@tanstack/react-router';
import Early from '@/pages/Early';

export const Route = createFileRoute('/early')({
  component: Early,
});
